import { render, staticRenderFns } from "./vipRecharge.vue?vue&type=template&id=72ee59e9&scoped=true&"
import script from "./vipRecharge.vue?vue&type=script&lang=js&"
export * from "./vipRecharge.vue?vue&type=script&lang=js&"
import style0 from "./vipRecharge.vue?vue&type=style&index=0&id=72ee59e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee59e9",
  null
  
)

export default component.exports